import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MicrophoneIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.02 14.3C10.1 14.3 8.92 12.9 8.92 10.94V6.82C8.92 4.86 10.1 3.48 12.02 3.48C13.94 3.48 15.12 4.86 15.12 6.82V10.94C15.12 12.9 13.94 14.3 12.02 14.3ZM12.02 12.76C12.9 12.76 13.54 12.02 13.54 11.1V6.66C13.54 5.74 12.9 5.02 12.02 5.02C11.14 5.02 10.5 5.74 10.5 6.66V11.1C10.5 12.02 11.14 12.76 12.02 12.76ZM12 15.88C14.74 15.88 16.78 13.64 16.78 10.96H18.4C18.4 14.2 16.18 16.84 12.84 17.46V20.38H11.16V17.46C7.84 16.84 5.62 14.2 5.62 10.96H7.24C7.24 13.66 9.28 15.88 12 15.88Z" />
    </SvgIcon>
  );
});
